import React from "react";


const DataradeComponent = () => {
  return (
    <div className="about_area mt-55 mb-100 pb-60 press-r">
      <div className="container">
        <div className="row d-flex align-items-center pd_gap nagative_mb">
          <div className="col-lg-6">
            <div className="about_skill_thumb mb-4 ml-2 mr-4">
              <img src={"/assets/images/Datarade-Pulse.webp"} alt="Datarade pulse" />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="section_title text_left mb-4">
             

              <div className="section_main_title text-left">
                <h5>ProPlus Data in The Datarade Pulse April 25</h5>
               
              </div>

              

              <div className="section_content_text pt-3 datarade">
                <p>
                The <a href="https://datarade.substack.com/p/the-datarade-pulse-news-and-insights-2a6" target="_blank" rel="noreferrer">Datarade Pulse</a> curates some of the most impactful updates and trusted data providers in the ecosystem, and being featured is a testament to our:</p>
                <ul className="text-left black">
                    <li>✅ High-quality, verified insights</li>
                    <li>✅ Global reach and precision targeting capabilities</li>
                    <li>✅ Commitment to compliance</li>
                </ul>
                <p>This feature reinforces our belief that data is only as valuable as it is foresight driven, usable, compliant, and context-aware. Whether it's identifying key buyer groups or building hyper-targeted campaigns, <a href="https://proplusdata.co/" target="_blank" rel="noreferrer">ProPlus Data</a> empowers your sales and marketing teams to work smarter.
                </p>
                <p>Read More At: <a href="https://datarade.substack.com/p/the-datarade-pulse-news-and-insights-2a6" target="_blank" rel="noreferrer"> DATARADE PULSE </a> |<a href="https://www.linkedin.com/pulse/proplus-data-datarade-pulse-april-25-proplus-data-qleoc" target="_blank" rel="noreferrer"> LINKEDIN </a></p>
              </div>
            </div>

          

          </div>
        </div>
      </div>
    </div>
  );
};

export default DataradeComponent;
